import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import { updateBusiness } from 'redux/modules/business';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';
import objectDiff from 'utils/objectDiff';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  form: {
    margin: '10px 40px',
    minHeight: 240,
  },
  typography: {
    paddingBottom: 2,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

function onSubmit(values, dispatch, props) {
  const diffValues = objectDiff(values, props.initialValues);
  return new Promise((resolve, reject) => {
    dispatch(updateBusiness({
      values: {
        'Company Info': props.initialValues.ID ? {
          ID: props.initialValues.ID,
          ...diffValues,
        } : values,
      },
      resolve,
      reject,
      showNotification: false,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessGeneralCompanyInformationForm = ({ handleSubmit, error, classes }) => (
  <form
    className={classes.form}
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classNames(classes.grid, classes.gridGutter)}
      container
      spacing={24}
    >
      <Grid item xs={12}>
        <Typography className={classes.typography} align="center">
          Check and Make Sure you entered all the correct information
        </Typography>
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item xs={12}>
        <Field
          id="Company Name"
          name="Company Name"
          label="Company Name *"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="bottom"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item xs={6}>
        <Field
          id="Signer First Name"
          name="Signer First Name"
          label="Signer First Name *"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="top"
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          id="Signer Last Name"
          name="Signer Last Name"
          label="Signer Last Name *"
          component={TextField}
          validate={[validate.required]}
          errorPlacement="top"
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

BusinessGeneralCompanyInformationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessGeneralCompanyInformationForm.defaultProps = {
  error: null,
};

export default reduxForm({
  form: 'companyInformation',
  enableReinitialize: true,
  onSubmit,
})(withStyles(styles)(BusinessGeneralCompanyInformationForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessGeneralDialog/BusinessGeneralCompanyInformationForm.js